import api from '@/tools/api-tools'
import axios from 'axios'
import * as urls from '../../config/net'
import resUrl from './resource-url'

// const HARD_WARE_TYPE = 2

const SAAS_TYPE = 1

class ItemData {
  saveCoupon (type = null) {
    return api.get(`${urls.mainWeb}/onlinemall/ajax/Act2018518.ashx?type=${type}`)
  }

  getShortUrl () {
    return api.get(`${urls.apiUrl}/v0/recommend/info`).then(res => {
      let data = res.data.data || {}
      console.log('shortUrl', data.shortUrl)
      return data.shortUrl
    }).catch(e => {
      console.log(e)
    })
  }

  getPVApiUrl () {
    return api.get(`http://cloud.fe.laoban100.com/cloud/5a8e6af24710cdd4b0399201/mall/pv/count`).then(res => {
      console.log(res.data)
      return res.data || {}
    })
  }

  setPVCount (url) {
    axios.get(url)
  }

  getRealImage () {
    return axios.get(`http://cloud.fe.laoban100.com/cloud/5ae309f48a5639f5d6cae15a/hybrid/laoban/realsale/second`).then(res => {
      return res.data
    })
  }

  // 获取商品详情（积分）
  getUserInfo (goodsId, remark = '') {
    let payObj = {goodsId: goodsId, goodsType: SAAS_TYPE, quantity: 1, couponCode: '', remark: remark}
    return api.post(resUrl.mainWebUrl, urls.mainWebPostData('businfo', payObj)).then(res => {
      let model = JSON.parse(res.data.Model) || {}
      return model
    }).catch(e => {
      console.log(e)
    })
  }

  // 移动端正式分享页
  getShareImage () {
    return api.get(`http://cloud.fe.laoban100.com/cloud/5ae309f48a5639f5d6cae15a/hybrid/laoban/realsale/share/second`).then(res => {
      return res.data
    })
  }
}

export default ItemData



// WEBPACK FOOTER //
// ./src/model/laoban/index.js